import React from "react";
import PropTypes from "prop-types";
import { Alert, Button } from "@opendate-app/setlist";
import client from "../../../shared/api/client";

export const turnOnGiftCardSales = (settingsPath) => client.patch(settingsPath, { team: { gift_cards_enabled: true } });

export const turnOnFailedMessage = (requestError, prefix = "We couldn't turn gift card sales on.") => {
  const reasons = requestError?.response?.data?.errors;
  const reason =
    Array.isArray(reasons) && reasons.length > 0
      ? ` ${reasons.map((message) => String(message).replace(/[.!?]$/, "")).join(". ")}.`
      : "";
  return `${prefix}${reason} Try again from gift card settings.`;
};

export const giftCardSalesShape = PropTypes.shape({
  enabled: PropTypes.bool.isRequired,
  stillOnGiftUp: PropTypes.bool,
  settingsPath: PropTypes.string.isRequired,
});

const salesOffDescription = (sales, canManage) => {
  if (sales.stillOnGiftUp) {
    return "Buyers can't buy your gift cards yet. Your team still sells through Gift Up, so sales open as part of your move from Gift Up.";
  }
  if (!canManage) return "Buyers can't buy your gift cards until a team administrator turns sales on.";
  return "Buyers can't buy your gift cards until you turn sales on.";
};

const GiftCardSalesOffAlert = ({ sales, canManage, turningOn = false, onTurnOn }) => (
  <div className="gift-card-editor-alert" data-testid="gift-card-sales-off">
    <Alert
      color="warning"
      title="Gift card sales are off for your team"
      description={salesOffDescription(sales, canManage)}
      actions={
        canManage && (
          <div className="gift-card-sales-off-actions">
            {!sales.stillOnGiftUp && (
              <Button variant="primary" size="sm" onClick={onTurnOn} disabled={turningOn}>
                Turn on gift card sales
              </Button>
            )}
            <a className="gift-card-sales-off-link" href={sales.settingsPath}>
              Gift card settings
            </a>
          </div>
        )
      }
    />
  </div>
);

GiftCardSalesOffAlert.propTypes = {
  sales: giftCardSalesShape.isRequired,
  canManage: PropTypes.bool.isRequired,
  turningOn: PropTypes.bool,
  onTurnOn: PropTypes.func,
};

export default GiftCardSalesOffAlert;
